import React from 'react';
import {useSelector} from 'react-redux';

import en from '../../locales/en.js';
import pt from '../../locales/pt.js';

const i18n = {en, pt};

const Str = (key, lang) => {
    if (!lang) {
        lang = window.config.lang || 'en';
    }
    
    const text = (key || '').split('.').reduce((prev, cur) => {
        return (typeof prev[cur] !== 'undefined' ? prev[cur] : {})
    }, i18n[lang]);

    return typeof text === 'string' ? text : key;
}

export const Translate = (key, lang) => Str(key, lang);

export default (props) => {    
    const lang = useSelector(state => state.configState.lang);
    const text = Str(props.value, lang);

    return <>{text}</>;
};